import {css} from 'lit';
export const styles = css`:host {
  --height: 40px;
  --padding: 0 8px 0 16px;
  --background: var(--light-bg);
  --color: var(--dark-text);
  --font-weight: 600;
  --border-width: 1px 0 1px 1px;
  --border-color: var(--light-bg);
  --border-radius: 6px 0 0 6px;
  --icon-size: 1.2em;
  --icon-padding: 0;
  --icon-margin-left: 0;
  --icon-border-width: 1px 1px 1px 0;
  --icon-border-radius: 0 6px 6px 0;
  --icon-border-color: var(--light-bg);
  --icon-color: var(--dark-text);
  --icon-color-hover: var(--dark-text);
  --icon-color-active: var(--dark-text);
  --icon-background: var(--light-bg);
  --icon-background-hover: var(--secondary-300);
  --icon-background-active: var(--secondary-400);

  display: flex;
  font-size: 0.9em;
  justify-content: space-between;
  height: var(--height);
}

input {
  height: 100%;
  width: 100%;
  flex: 1 1 auto;
  padding: var(--padding);
  background-color: var(--background);
  border-width: var(--border-width);
  border-color: var(--border-color);
  border-style: solid;
  border-radius: var(--border-radius);
  color: var(--color);
  font-weight: var(--font-weight);
  outline: none;
}

button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--height);
  height: 100%;
  margin-left: var(--icon-margin-left);
  padding: var(--icon-padding);
  background-color: var(--icon-background);
  border-width: var(--icon-border-width);
  border-color: var(--icon-border-color);
  border-style: solid;
  border-radius: var(--icon-border-radius);
  color: var(--icon-color);
  font-size: var(--icon-size);
}

button.focus-visible {
    outline: 1px solid var(--link-focus-outline);
    outline-offset: -2px;
  }

button:focus-visible {
    outline: 1px solid var(--link-focus-outline);
    outline-offset: -2px;
  }

@media (hover: hover) {
    button:hover {
      background-color: var(--icon-background-hover);
      color: var(--icon-hover);
    }
  }

button:active {
    background-color: var(--icon-background-active);
    color: var(--icon-active);
  }
`;
export default styles;
